import { render, staticRenderFns } from "./MessageIframe.vue?vue&type=template&id=423acc0a&scoped=true&"
import script from "./MessageIframe.vue?vue&type=script&lang=js&"
export * from "./MessageIframe.vue?vue&type=script&lang=js&"
import style0 from "./MessageIframe.vue?vue&type=style&index=0&id=423acc0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423acc0a",
  null
  
)

export default component.exports